import React, { lazy } from 'react'
import ComponentLoader from './component-loader'
import { Navigate } from 'react-router-dom'
import UnAuthorizeLayout from 'screens/unauthorize/unauthorize-layout'

const InvalidAccess = ComponentLoader(
  lazy(() => import('screens/unauthorize/invalid-access'))
)

const Profile = ComponentLoader(
  lazy(() => import('screens/admin/Profile/profile'))
)

const InvalidAccessRoutes = [
  {
    path: '',
    element: <UnAuthorizeLayout />,
    children: [
      {
        path: '/unauthorize',
        index: true,
        element: <InvalidAccess />,
      },
      {
        path: '/profile',
        element: (
          <div className='max-w-3xl mx-auto'>
            <Profile />
          </div>
        ),
      },
      {
        path: '',
        element: <Navigate replace to={'/unauthorize'} />,
      },
      {
        path: '*',
        element: <Navigate replace to={'/unauthorize'} />,
      },
    ],
  },
]

export default InvalidAccessRoutes
